import { Notification } from 'omni-common-ui';
import * as _actions from './actions';
import _reducer from './reducer';
import * as _accessors from './accessors';

export const reducer = _reducer;
export const actions = _actions;
export const accessors = _accessors;

export default Notification;



// WEBPACK FOOTER //
// ./data/Users/Notifications/index.js